import React, { useState } from "react";
import { Modal } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useIntl } from "react-intl";
import { useGlobalCore } from "../../../cores/globals";
import "./SocialWallBoardModal.scss";

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (name: string) => void;
}

export function SocialWallBoardModal({ isOpen, onCancel, onConfirm }: Props) {
  const intl = useIntl();
  const { isDarkMode } = useGlobalCore();
  const [name, setName] = useState("");

  const submit = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
    setName("");
  };

  const close = () => {
    setName("");
    onCancel();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={close}
      centered
      zIndex={1060}
      className="sw-board-modal-dialog"
      modalClassName={isDarkMode ? "sw-board-modal--dark" : undefined}
      backdropClassName="sw-board-modal__backdrop"
      onOpened={() => setName("")}
    >
      <div className="sw-board-modal">
        <button
          type="button"
          className="sw-board-modal__close"
          onClick={close}
          aria-label={intl.formatMessage({ id: "app.socialWall.close" })}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="sw-board-modal__icon" aria-hidden>
          <FontAwesomeIcon icon={faLayerGroup} />
        </div>

        <h3 className="sw-board-modal__title">
          {intl.formatMessage({ id: "app.socialWall.newBoard" })}
        </h3>
        <p className="sw-board-modal__body">
          {intl.formatMessage({ id: "app.socialWall.newBoardPrompt" })}
        </p>

        <input
          className="sw-board-modal__input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={intl.formatMessage({
            id: "app.socialWall.defaultBoard",
          })}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              submit();
            }
          }}
        />

        <div className="sw-board-modal__actions">
          <button
            type="button"
            className="sw-board-modal__btn sw-board-modal__btn--ghost"
            onClick={close}
          >
            {intl.formatMessage({ id: "app.socialWall.deletePostCancel" })}
          </button>
          <button
            type="button"
            className="sw-board-modal__btn sw-board-modal__btn--primary"
            onClick={submit}
            disabled={!name.trim()}
          >
            {intl.formatMessage({ id: "app.socialWall.createBoard" })}
          </button>
        </div>
      </div>
    </Modal>
  );
}
